export enum Severity {
  TRACE = 1,
  DEBUG,
  LOG,
  INFO,
  WARN,
  ERROR,
}
